__turbopack_context__.v({
  "report-event-wrapper": "CreatorCollectionsLink-module-scss-module__qmLl2G__report-event-wrapper",
  "root": "CreatorCollectionsLink-module-scss-module__qmLl2G__root",
});
